import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSettings } from 'core/hooks/useSettings'
import Drawer from 'core/components/drawer/Drawer'
import { TripDetailRef } from 'core/widgets/trip-detail/TripDetail'
import { useQueryClient } from 'react-query'
import UnsavedModal from 'core/components/dialogs/UnsavedModal'
import useUrlSearch from 'core/hooks/useUrlSearch'
import useNavigation from 'core/hooks/useNavigation'
import { TripsUrl } from 'constants/RouteUrls'
import TripDetail from 'core/widgets/trip-detail/TripDetailLazy'

const TripDetailDrawer = () => {
  const { set, get } = useSettings()
  const { tokenId, view, props } = get('tripDetail') ?? {}
  const queryClient = useQueryClient()
  const tripDetailRef = useRef<TripDetailRef>(null)
  const [showUnsavedModal, setShowUnsavedModal] = useState(false)
  const [urlParams, setUrlParams] = useUrlSearch()
  const { pathname } = useNavigation()
  const handleClose = useCallback(() => {
    setShowUnsavedModal(false)
    queryClient.invalidateQueries({ queryKey: ['trip', tokenId] })
    set('tripDetail', {
      tokenId: '',
      props: {}
    })
  }, [queryClient, set, tokenId])

  const handleBeforeClose = useCallback(() => {
    if (!tripDetailRef?.current?.getFormDirty()) {
      return handleClose()
    }

    setShowUnsavedModal(true)
  }, [handleClose])

  useEffect(() => {
    if (pathname !== TripsUrl) return

    const selectedParam = urlParams.get('t_sr')

    if (tokenId && tokenId !== 'new-trip-id' && !selectedParam) {
      urlParams.set('t_sr', tokenId)
      setUrlParams(urlParams)
    }

    if (!tokenId && selectedParam) {
      urlParams.delete('t_sr')
      setUrlParams(urlParams)
    }
  }, [pathname, setUrlParams, tokenId, urlParams])

  return (
    <Drawer
      show={!!tokenId}
      startFrom="right"
      onClose={handleBeforeClose}
      width="w-full md:w-2/4 lg:w-2/6"
      canExpand={false}
      contentClassNames="overflow-scroll h-screen"
    >
      <TripDetail
        ref={tripDetailRef}
        view={view}
        tripId={tokenId}
        onError={() => {
          props?.onError?.()
        }}
        onSuccess={() => {
          props?.onSuccess?.()
          handleClose()
        }}
        enableEndDate={props?.enabledEndDate ?? null}
        enableStartDate={props?.enabledStartDate ?? null}
      />
      <UnsavedModal
        active={showUnsavedModal}
        overrideShow={showUnsavedModal}
        saveButtonText="Keep editing"
        onExit={() => {
          setShowUnsavedModal(false)
          setTimeout(() => {
            handleClose()
          }, 500)
        }}
        onSave={() => {
          setShowUnsavedModal(false)
        }}
      />
    </Drawer>
  )
}

export default TripDetailDrawer
